import React from 'react';
import clsx from 'clsx';
import SearchIcon from '../../assets/icons/search.svg';
import './SearchInput.css';

const SearchInput = ({ placeholder, className, onChange }) => {
  return <div className={clsx('search-input', className)}>
    <img src={SearchIcon} alt="Search" />
    <input placeholder={placeholder} onChange={(evt) => onChange(evt.target.value)}/>
  </div>;
}

export default SearchInput;
